import { createReducer, on } from '@ngrx/store';
import { addItem, removeItem, clearAll, updateBoundsSuccess, addItems } from '../actions/map-draw.actions';

export interface DrawnItem {
	id: string;
	type: string;
	coordinates: number[][];
}

export interface MapDrawState {
	drawnItems: DrawnItem[];
	bounds: { minLat: number; maxLat: number; minLng: number; maxLng: number } | null;
}

const initialState: MapDrawState = {
	drawnItems: [],
	bounds: null
};

export const mapDrawReducer = createReducer(
	initialState,
	on(addItem, (state, { item }) => ({
		...state,
		drawnItems: [...state.drawnItems, item]
	})),
	on(addItems, (state, { items }) => ({
		...state,
		drawnItems: [...state.drawnItems, ...items]
	})),
	on(removeItem, (state, { itemId }) => ({
		...state,
		drawnItems: state.drawnItems.filter(item => !item.id.startsWith(itemId))
	})),
	on(clearAll, state => ({
		...state,
		drawnItems: [],
		bounds: null
	})),
	on(updateBoundsSuccess, (state, { bounds }) => ({
		...state,
		bounds
	}))
);
